import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=1c40bd39"
import script from "./Objects.vue?vue&type=script&lang=ts"
export * from "./Objects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports